import {observer} from 'mobx-react';
import FormRow from '../../../../../forms/FormRow';
import FormColumn from '../../../../../forms/FormColumn';
import FormAutocompleteField from '../../../../../components/fields/FormAutocompleteField';

function CustomerSubjectPanel({allowance, subsectionForm, readOnly = false}) {
    return (
        <FormColumn>
            <FormRow>
                <FormAutocompleteField
                    label="Razón social"
                    form={subsectionForm}
                    fieldName="customerId"
                    options={allowance.customerOptions()}
                    readOnly={readOnly}
                />
            </FormRow>
        </FormColumn>
    );
}

export default observer(CustomerSubjectPanel);
